import { FC } from "react"
import Skeleton from "../base"

const TAB_WIDTHS = [96, 72, 104, 56, 112, 136, 88]

const BrandDetailsSkeleton: FC = () => (
  <div className="h-full bg-white">
    {/* Header */}
    <Skeleton className="px-6 pt-4 pb-5 border-b border-gray-100">
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 mb-4">
        <div className="h-3.5 w-14 rounded bg-gray-200" />
        <div className="h-3 w-2 rounded bg-gray-200" />
        <div className="h-3.5 w-24 rounded bg-gray-200" />
      </div>

      {/* Brand identity row */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {/* Logo */}
          <div className="h-12 w-20 rounded bg-gray-200" />
          <div className="space-y-1.5">
            {/* Brand name */}
            <div className="h-5 w-40 rounded bg-gray-200" />
            {/* ID · NMLS */}
            <div className="h-3.5 w-48 rounded bg-gray-200" />
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-lg bg-gray-200" />
          <div className="h-9 w-9 rounded-lg bg-gray-200" />
        </div>
      </div>
    </Skeleton>

    {/* Tabs */}
    <Skeleton className="px-6 border-b border-gray-100">
      <div className="flex gap-6 pt-1">
        {TAB_WIDTHS.map((w, i) => (
          <div key={i} className="pb-3 pt-2">
            <div
              className="h-3.5 rounded bg-gray-200"
              style={{ width: `${w}px` }}
            />
          </div>
        ))}
      </div>
    </Skeleton>

    {/* Content — field/value pairs */}
    <Skeleton className="px-6 py-6">
      <div className="grid grid-cols-2 gap-x-12 gap-y-6 max-w-xl">
        {/* Single-column full-width field */}
        <div className="col-span-2 space-y-1.5">
          <div className="h-3 w-10 rounded bg-gray-200" />
          <div className="h-4 w-20 rounded bg-gray-200" />
        </div>

        {/* Two-column field pairs */}
        {Array.from({ length: 3 }).map((_, row) => (
          <div key={row} className="col-span-2 grid grid-cols-2 gap-x-12">
            <div className="space-y-1.5">
              <div className="h-3 w-28 rounded bg-gray-200" />
              <div
                className="h-4 rounded bg-gray-200"
                style={{ width: `${120 + row * 20}px` }}
              />
            </div>
            <div className="space-y-1.5">
              <div className="h-3 w-36 rounded bg-gray-200" />
              <div className="h-4 w-16 rounded bg-gray-200" />
            </div>
          </div>
        ))}
      </div>
    </Skeleton>
  </div>
)

export default BrandDetailsSkeleton
